// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"52":"48fa3f67","500":"3d4c0007","644":"5cf1451c"}[chunkId] + ".js";
};